// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfitList_wrapper__+o4AW","list":"ProfitList_list__XtRWc","list__items":"ProfitList_list__items__7xyry"};